import styled from 'styled-components'
import colors from '../../../assets/colors'

export const Container = styled.div`
    background-color: ${colors.white};
    color: ${colors.darkGrey};
    padding: 8px 45px;
  }
`
